import { StrategyBuilderFunction, EMPTY_STRATEGY } from './types';
import { addLongPut, addShortPut } from './addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from './utils';

export const bullPutSpread: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Define strike prices for the bull put spread using the spot price adjustments
  const lowerStrike = findClosestStrikePrice(
    strikesAtExpiration,
    getStrikeDistance({ price: spot, unit: -2 }),
  );
  const higherStrike = findClosestStrikePrice(strikesAtExpiration, spot);

  return {
    optionPositions: [
      // Sell a put option at the higher strike price
      addShortPut({
        strike: higherStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[higherStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[higherStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'short'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
      // Buy a put option at the lower strike price
      addLongPut({
        strike: lowerStrike,
        premium: getPremium({
          ask: strikesAtExpiration?.c?.[lowerStrike]?.p?.a || 0,
          bid: strikesAtExpiration?.c?.[lowerStrike]?.p?.b || 0,
          strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
        }),
        expirationDate: expirationDateForOptions,
        expirationKey: expirationKeyForOptions,
        numberOfContracts: 1 * contractMultiplier,
      }),
    ],
    stockPositions: [],
  };
};
